import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function BackdatingIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = "primary";
  const color = props.color || defaultColor;
  return (
      <SvgIcon
          {...props}
          color={color}
          xmlns="http://www.w3.org/2000/svg"
          x={0}
          y={0}
          viewBox="0 0 24 24"
          xmlSpace="preserve"
          enableBackground="new 0 0 24 24"
          titleAccess="Backdating">
          <path
              fillRule="evenodd"
              d="M7.715 4.38a6.347 6.347 0 0 1 9.93 7.773.748.748 0 0 0 1.276.781A7.843 7.843 0 1 0 4.384 8.9a.748.748 0 1 0 1.497-.01 6.325 6.325 0 0 1 1.834-4.51Z"
              clipRule="evenodd"
          />
          <path
              d="m5.525 11.101 2.04-2.063a.499.499 0 0 0-.357-.85l-4.104.023a.499.499 0 0 0-.348.853l2.063 2.041a.499.499 0 0 0 .706-.004Z"
          />
          <path
              fillRule="evenodd"
              d="M7.554 20.345c0-.413.335-.748.748-.748h6.777a.748.748 0 0 1 0 1.496H8.302a.748.748 0 0 1-.748-.748Z"
              clipRule="evenodd"
          />
          <path
              fillRule="evenodd"
              d="M18.413 13.604c-1.128-.074-4.329-.273-6.246-.273-1.008 0-1.905.365-2.833.85-.203.105-.414.221-.63.34-.713.393-1.49.82-2.258 1.041-.874.252-1.87.442-2.681.573-.635.103-1.106.616-1.146 1.215l-.122 1.856a.25.25 0 0 0 .249.266h1.552a.748.748 0 0 1 0 1.496H2.746a1.746 1.746 0 0 1-1.742-1.86l.122-1.856c.088-1.336 1.118-2.386 2.4-2.594.787-.128 1.716-.307 2.505-.534.594-.171 1.16-.482 1.83-.85.245-.134.503-.275.78-.42.988-.516 2.148-1.02 3.526-1.02 1.976 0 5.227.203 6.344.277.453.03.873.235 1.175.57l.611.675c.372.41.668.882.877 1.395l1.034 2.545c.253.621.269 1.314.045 1.947l-.243.686a1.746 1.746 0 0 1-1.646 1.165h-1.36a.748.748 0 0 1 0-1.497h1.36a.25.25 0 0 0 .235-.166l.243-.687a1.247 1.247 0 0 0-.02-.885l-1.035-2.545a3.243 3.243 0 0 0-.6-.954l-.61-.676a.242.242 0 0 0-.164-.08Z"
              clipRule="evenodd"
          />
          <path
              fillRule="evenodd"
              d="M17.125 19.407a1.08 1.08 0 1 0 0 2.162 1.08 1.08 0 0 0 0-2.162Zm-2.577 1.081a2.578 2.578 0 1 1 5.155 0 2.578 2.578 0 0 1-5.155 0ZM6.15 19.407a1.081 1.081 0 1 0 0 2.162 1.081 1.081 0 0 0 0-2.162Zm-2.578 1.081a2.578 2.578 0 1 1 5.155 0 2.578 2.578 0 0 1-5.155 0Z"
              clipRule="evenodd"
          />
      </SvgIcon>
  );
}
